const appID = "758";

const useCreate = () => {
  return { appID };
};

export type Props = ReturnType<typeof useCreate>;

export default useCreate;
